import React, { useEffect, useMemo, useState } from "react";
import { TextField, Button, Grid, Table, TableRow, TableBody, TableCell, Paper } from '@material-ui/core';
import Sockets from '../../Sockets';
import axios from "axios";

const generateUserGuid = () => {
    var nav = window.navigator;
    var screen = window.screen;
    var guid = nav.mimeTypes.length;
    guid += nav.userAgent.replace(/\D+/g, '');
    guid += nav.plugins.length;
    guid += screen.height || '';
    guid += screen.width || '';
    guid += screen.pixelDepth || '';

    return guid;
};

const getUserGuid = () => {
    let guid = window.localStorage.getItem('socketUserGuid');
    if (!guid) {
        guid = generateUserGuid();
        window.localStorage.setItem('socketUserGuid', guid);
    }

    return guid;
};

const Chat = () => {   
    const [text, setText] = useState('');
    const [messages, setMessages] = useState([]);
    const userId = useMemo(() => {
        return getUserGuid();
    }, []);
    
    useEffect(() => {
        Sockets.shared().echo.channel('chat').listen('ChatEvent', (data) => {
            console.log(`reiceved new message from socket`, data);
            setMessages(m => [...m, data]);
        });
    }, []);

    const handleSend = async () => {
        await axios.post('/sendslackmessage', { text });
        setText('');
    };

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Paper>
                    <Table>
                        <TableBody>
                            {messages.map((message, i) => (
                                <TableRow key={`message_${i}`}>
                                    <TableCell align={message.isBotMessage ? 'right' : 'left'} color="primary">
                                        {message.message}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Paper>
            </Grid>
            <Grid item xs={12}>
                <TextField 
                    fullWidth
                    value={text}
                    onChange={e => setText(e.target.value)}
                    placeholder="Text..."
                />
            </Grid>
            <Grid item xs={12}>
                <Button fullWidth variant="contained" color="primary" onClick={handleSend}>Send</Button>
            </Grid>
        </Grid>
    );
};
export default Chat;